import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from 'styled-components';
import { muiTheme, theme } from './theme';
import { AuthProvider } from './stores/AuthContext';
import ConsultingLanding from './features/consulting/pages/ConsultingLanding';
import ApexLanding from './features/platform/pages/ApexLanding';
import ContactUs from './features/consulting/pages/ContactUs';
import Landing from './features/auth/Landing';
import Login from './features/auth/Login';
import SignUp from './features/auth/SignUp';
import Dashboard from './features/dashboard/Dashboard';
import CreateIngestion from './features/ingestion/CreateIngestion';
import SnowflakeIntegration from './features/integrations/pages/SnowflakeIntegration';
import ApiTest from './features/dev/pages/ApiTest';
import ProtectedRoute from './features/auth/ProtectedRoute';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
    <MuiThemeProvider theme={muiTheme}>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<ConsultingLanding />} />
          <Route path="/platform" element={<ApexLanding />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/api-test" element={<ApiTest />} />
          <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/app/login" element={<Login />} />
          <Route path="/app/signup" element={<SignUp />} />
          <Route
            path="/app/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/ingestion/create"
            element={
              <ProtectedRoute>
                <CreateIngestion />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/integrations/snowflake"
            element={
              <ProtectedRoute>
                <SnowflakeIntegration />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
    </MuiThemeProvider>
    </ThemeProvider>
  );
}

export default App;
